import { Dialog, DialogContent } from "@material-ui/core";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { clearToken } from "../../helpers/utility";
import {
    fetchPaymentConfigRequest,
    fetchPlansRequest,
} from "../../store/shopping/shopping.actions";
import {
    getPaymentConfig,
    getUpgradePlan,
} from "../../store/shopping/shopping.selector";
import { getUserProfile } from "../../store/user/user.selector";
import StripePaymentForm from "../payment/stripePaymentForm";
var stripePromise = null;

const ELEMENTS_OPTIONS = {
    fonts: [
        {
            cssSrc: "https://fonts.googleapis.com/css?family=Roboto",
        },
    ],
};

const UpgradePlan = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [confirmed, setConfirmed] = useState(false);
    const [period, setPeriod] = useState("monthly");

    const { plans, userProfile, paymentConfig } = useSelector((state) => {
        return {
            plans: getUpgradePlan(state),
            userProfile: getUserProfile(state),
            paymentConfig: getPaymentConfig(state),
        };
    });

    useEffect(() => {
        dispatch(fetchPlansRequest());
        dispatch(fetchPaymentConfigRequest());
    }, []);

    useEffect(() => {
        if (paymentConfig && paymentConfig.publicKey) {
            stripePromise = loadStripe(paymentConfig.publicKey);
        }
    }, [paymentConfig]);

    return (
        <div className="px-2 sm:px-4 lg:px-8 py-7">
            <div className=" mb-[26px]">
                <h1 className="text-2xl font-bold text-ebony-color capitalize">
                    Upgrade Plan
                </h1>
            </div>

            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-x-3 gap-y-10">
                <div className="p-5 pb-[30px] bg-white rounded-2xl border-[1.5px] border-black-20">
                    <h2 className="text-xl font-bold text-black/80 mb-4 text-center">
                        $00.00/ month
                    </h2>
                    <div className="flex items-center gap-x-2 mb-[22px] text-sm text-black-60">
                        <p
                            className={`role text-ebony-color bg-black/5 font-bold py-1.5 px-[22px] rounded-full capitalize`}
                        >
                            starter
                        </p>
                        <p>Quick go-to-store</p>
                    </div>
                    <div className="mb-3.5">
                        <h4 className="text-base font-bold text-ebony-color mb-0.5">
                            Monthly Billing
                        </h4>
                        <p className="text-sm font-medium text-black-60">
                            This plan has no billing option
                        </p>
                    </div>

                    <div className="">
                        <h5 className="text-sm font-medium text-ebony-color">
                            Free
                        </h5>
                        <div className="flex items-center gap-x-3 justify-center mt-14 flex-col sm:flex-row gap-y-3">
                            <button className="py-2.5 px-[22px] rounded-lg text-white text-sm font-bold bg-orange-color  whitespace-nowrap w-full sm:w-fit">
                                Currently active
                            </button>
                            <button className="py-2.5 px-[22px] rounded-lg text-black-50 text-sm font-medium bg-white border border-border-color whitespace-nowrap w-full sm:w-fit">
                                View details
                            </button>
                        </div>
                    </div>
                </div>

                <div className="p-5 pb-[30px] bg-white rounded-2xl border-[1.5px] border-orange-color relative">
                    <button className="absolute left-2/4 -top-[26px] bg-white -translate-x-2/4  py-2 px-[17px] rounded-full font-bold text-orange-color border-[1.5px] border-orange-color text-sm capitalize">
                        best choice
                    </button>

                    <div className=" mb-4">
                        <h2 className="text-xl font-bold text-orange-color text-center">
                            $
                            {period === "monthly"
                                ? plans && plans[0] && plans[0].monthlyAmount
                                : plans && plans[0] && plans[0].yearlyAmount}
                            / {period === "monthly" ? "Month" : "Year"}
                        </h2>
                    </div>
                    <div className="flex items-center gap-x-2 mb-[22px] text-sm text-black-60">
                        <p
                            className={`role text-orange-color bg-[#FFF6EB] font-bold py-1.5 px-[22px] rounded-full uppercase`}
                        >
                            pro
                        </p>
                        <p>For professionals & brands</p>
                    </div>
                    <div className="mb-3.5">
                        <h4 className="text-base font-bold text-ebony-color mb-0.5">
                            Monthly Billing
                        </h4>
                        <p className="text-sm font-medium text-black-60">
                            You can select either monthly or yearly billing
                        </p>
                    </div>

                    <div className="">
                        <div className="">
                            <form className="">
                                <label
                                    htmlFor="billing-radio-1"
                                    className="flex items-center mb-2.5 cursor-pointer"
                                >
                                    <input
                                        id="billing-radio-1"
                                        type="radio"
                                        value=""
                                        checked={period === "monthly"}
                                        onClick={() => setPeriod("monthly")}
                                        name="default-radio"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <p className="ml-3 cursor-pointer text-sm font-medium text-ebony-color ">
                                        $
                                        {plans &&
                                            plans[0] &&
                                            plans[0].monthlyAmount}
                                        / month-monthly
                                    </p>
                                </label>
                                <label
                                    htmlFor="billing-radio-2"
                                    className="flex items-start cursor-pointer"
                                >
                                    <input
                                        id="billing-radio-2"
                                        type="radio"
                                        value=""
                                        checked={period === "yearly"}
                                        onClick={() => setPeriod("yearly")}
                                        name="default-radio"
                                        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                    />
                                    <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                    <div className="ml-3">
                                        <p className=" cursor-pointer text-sm font-medium text-ebony-color whitespace-nowrap w-full sm:w-fit ">
                                            $
                                            {plans &&
                                                plans[0] &&
                                                plans[0].yearlyAmount / 12}
                                            / month-yearly
                                        </p>
                                        <p className="text-extraSmall font-normal text-black-60">
                                            Total $
                                            {plans &&
                                                plans[0] &&
                                                plans[0].yearlyAmount}{" "}
                                            a year. 15% discount
                                        </p>
                                    </div>
                                </label>
                            </form>
                        </div>

                        <div className="flex items-center gap-x-3 justify-center mt-2.5 flex-col sm:flex-row gap-y-3">
                            <button
                                onClick={() => setConfirmed(true)}
                                className="py-2.5 px-[22px] rounded-lg text-white text-sm font-bold bg-orange-color whitespace-nowrap w-full sm:w-fit"
                            >
                                Upgrade to PRO
                            </button>
                            <button className="py-2.5 px-[22px] rounded-lg text-black-50 text-sm font-medium bg-white border border-border-color whitespace-nowrap w-full sm:w-fit">
                                View details
                            </button>
                        </div>
                    </div>
                </div>

                <div className="p-5 pb-[30px] bg-white rounded-2xl border-[1.5px] border-purple-color relative overflow-hidden">
                    <div className="">
                        <h2 className="text-xl font-bold text-purple-color mb-4 text-center">
                            Let’s talk
                        </h2>
                        <div className="flex items-center gap-x-2 mb-[22px] text-sm text-black-60">
                            <p
                                className={`role text-purple-color bg-[#F8F2FF] font-bold py-1.5 px-[22px] rounded-full capitalize`}
                            >
                                Enterprise
                            </p>
                            <p>For large corporations</p>
                        </div>
                        <div className="mb-3.5">
                            <h4 className="text-base font-bold text-ebony-color mb-0.5">
                                Monthly Billing
                            </h4>
                            <p className="text-sm font-medium text-black-60">
                                Billing option coming soon
                            </p>
                        </div>

                        <div className="mt-[90px]">
                            <div className="flex items-center gap-x-3 justify-center flex-col sm:flex-row gap-y-3">
                                <button className="py-2.5 px-[22px] rounded-lg text-white text-sm font-bold bg-orange-color  whitespace-nowrap w-full sm:w-fit">
                                    Upgrade Plan
                                </button>
                                <button className="py-2.5 px-[22px] rounded-lg text-black-50 text-sm font-medium bg-white border border-border-color whitespace-nowrap w-full sm:w-fit">
                                    View details
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="absolute top-0 right-0 bottom-0 left-0 bg-white/50 z-10"></div>

                    <div className="py-3 text-xl font-bold text-white bg-purple-color text-center absolute bottom-12 left-[30%] w-full -rotate-45">
                        Coming soon
                    </div>
                </div>
            </div>
            <Dialog open={confirmed} onClose={() => setConfirmed(false)}>
                <DialogContent>
                    {stripePromise && confirmed ? (
                        <Elements
                            stripe={stripePromise}
                            options={ELEMENTS_OPTIONS}
                        >
                            <StripePaymentForm
                                type="account-upgrade"
                                paymentConfig={paymentConfig}
                                OnSuccess={() => {
                                    setPeriod(false);
                                    setConfirmed(false);
                                    navigate("/page/successfullyUpgraded");
                                }}
                                onCancel={() => {
                                    setConfirmed(false);
                                }}
                                OnError={(err) => {
                                    setPeriod(false);
                                    setConfirmed(false);
                                    Swal.fire({
                                        title: "Upgrade Failed",
                                        text: err.message,
                                        icon: "error",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        showConfirmButton: false,
                                        cancelButtonText: "Close",
                                        customClass: {
                                            cancelButton: "order-1 right-gap",
                                            confirmButton: "order-2",
                                            denyButton: "order-3",
                                        },
                                    }).then((x) => {
                                        if (x.isConfirmed) {
                                            clearToken();
                                            document.location.href = "/";
                                        }
                                    });
                                }}
                                userId={userProfile._id}
                                billingPeriod={period}
                                description={
                                    <div>
                                        <p className="my-2">
                                            <input type="checkbox" checked />{" "}
                                            Remember for all{" "}
                                            <a href="#">Ulalive purchases</a> on
                                            any device
                                        </p>
                                        <p className="text-ebony my-2">
                                            Your bank may charge a cross-border
                                            or currency exchange fee.
                                        </p>
                                        <p className="text-black-100 my-2">
                                            Billing starts on{" "}
                                            {moment().format("DD MMMM YYYY")}{" "}
                                            {
                                                period === "yearly" ?
                                                    " and will end at " +
                                                    moment()
                                                        .add(
                                                            1,
                                                            period === "monthly"
                                                                ? "month"
                                                                : "year"
                                                        )
                                                        .format("DD MMMM YYYY") : " and will be recurring every month"
                                            }
                                            .
                                        </p>
                                        <p className="text-black-50 my-2">
                                            All prices include applicable taxes.
                                            By continuing, you verify that you
                                            are atlest 18 years old and agree to{" "}
                                            <a href="#">these terms</a>.
                                        </p>
                                    </div>
                                }
                            />
                        </Elements>
                    ) : (
                        <span />
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default UpgradePlan;
